// @ts-expect-error not migrated to TS yet
import ErrorBoundary from 'EmailComponents/errors/ErrorBoundary';
// @ts-expect-error not migrated to TS yet
import AsyncPortalSuspensionAlertContainer from 'email-management-lib/refactor/containers/AsyncPortalSuspensionAlertContainer';
// @ts-expect-error not migrated to TS yet
import EmailPageContainer from 'email-management-lib/refactor/containers/EmailPageContainer';
// @ts-expect-error not migrated to TS yet
import AsyncAssignAssetAccessPanelContainer from 'email-management-lib/refactor/containers/AsyncAssignAssetAccessPanelContainer';
// @ts-expect-error not migrated to TS yet
import AsyncMoreToolsModalContainer from 'email-management-lib/refactor/components/manage/sidebar/AsyncMoreToolsModalContainer';
import { initParams, updateQueryAndPathParams, updateQueryParams // @ts-expect-error not migrated to TS yet
} from 'EmailData/actions/params';
import { getHasAccessToEmailApprovalReadScope, getHasAssignAssetAccess, getHasUsersTeamsAccess, getIsFreeEmail, getIsStarterEmail, getShouldDisableCreateEmailAction, getShouldUseBUPicker // @ts-expect-error not migrated to TS yet
} from 'EmailData/selectors/user';
// @ts-expect-error not migrated to TS yet
import { showPortalSuspensionSelector } from 'EmailData/portalStatus/selectors';
// @ts-expect-error not migrated to TS yet
import { feedbackClientSelector } from 'EmailData/selectors/feedbackClient';
// @ts-expect-error not migrated to TS yet
import { getEmailCreditUsed } from 'EmailData/selectors/portalSendCreditsSelectors';
// @ts-expect-error not migrated to TS yet
import { clearEmailSearch } from 'email-management-lib/refactor/actions/general';
// @ts-expect-error not migrated to TS yet
import { setComparisonToolReturnLocation } from 'email-management-lib/refactor/actions/comparison/comparisonToolActions';
import { fetchEmails } from 'email-management-lib/refactor/actions/manage/general';
import AsyncBannerTableContainer from 'email-management-lib/refactor/components/manage/async/AsyncBannerTableContainer';
import AsyncDetailsPanel from 'email-management-lib/refactor/components/manage/async/AsyncDetailsPanel';
import AsyncListingAlert from 'email-management-lib/refactor/components/manage/async/AsyncListingAlert';
import AsyncMarketingHomePopup from 'email-management-lib/refactor/components/manage/async/AsyncMarketingHomePopup';
import AsyncSuspensionBanner from 'email-management-lib/refactor/components/manage/async/AsyncSuspensionBanner';
import EmailHeaderSubtitle from 'email-management-lib/refactor/components/manage/EmailHeaderSubtitle';
import FrameworkTable from 'email-management-lib/refactor/components/manage/frameworkTable/FrameworkTable';
import FrameworkTableProvider from 'email-management-lib/refactor/components/manage/frameworkTable/FrameworkTableProvider';
import InsightContextProvider from 'email-management-lib/refactor/components/manage/frameworkTable/InsightContextProvider';
import AsyncProbationBannerContainer from 'email-management-lib/refactor/containers/AsyncProbationBannerContainer';
import Header from 'EmailComponents/Header';
import getBUFromLocalStorage, { ALL_BUSINESS_UNITS } from 'EmailComponents/utils/getBUFromLocalStorage';
import { trackDashboardScreenChange } from 'EmailComponents/utils/tracking';
import router from 'EmailData/utils/history';
import { useCallback, useEffect, useMemo } from 'react';
import CreateEmailPanel from 'email-management-lib/EmailCreation/components/CreateEmailPanel/CreateEmailPanel';
import EmptyStateWithTemplatesAsync from 'email-management-lib/Onboarding/components/EmptyStateWithTemplatesAsync';
import useEmptyState from 'email-management-lib/Onboarding/hooks/useEmptyState';
import { useTrackerWithSR } from 'email-management-lib/Onboarding/hooks/useTrackerWithSR';
import { logTreatmentExposure } from 'email-management-lib/refactor/actions/experiments';
import { selectState } from 'email-management-lib/refactor/actions/manage/filtering';
import { fetchSentEmailsCount, maybeFetchHasArchivedEmailsByCrmSearch, maybeFetchHasEmailsByCrmSearch } from 'email-management-lib/refactor/actions/manage/general';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
import { MC0653_TREATMENT_KEY } from 'email-management-lib/refactor/constants/experimentConstants';
import useRouter from 'email-management-lib/refactor/hooks/useRouter';
import { getIsMc0653Audience, getShowMc0653Variation } from 'email-management-lib/refactor/selectors/experiments';
import { getHasArchivedEmailsData, getHasEmailsData, getSelectedEmailCrmObject } from 'email-management-lib/refactor/selectors/manage/table';
import manageEmailPrefetcher from 'email-management-lib/refactor/utils/performance/managePrefetcher';
import AsyncYearInReviewBannerWrapper from 'email-management-lib/refactor/yearInReview/components/AsyncYearInReviewBannerWrapper';
import emailFrameworkFoldersTour, { EMAIL_FRAMEWORK_FOLDERS_TOUR_ID } from 'email-management-lib/tours/frameworkFoldersTour';
import { fetchApprovalsConfig } from 'EmailData/actions/approvals';
import { enrollPortalForGettingStarted } from 'EmailData/actions/dashboardZeroState';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { stringify } from 'hub-http/helpers/params';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import { useDispatch, useSelector } from 'react-redux';
import MC0653UsageLimitBanner from 'ui-addon-upgrades/mc-0653/MC0653UsageLimitBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This is to remove the padding-bottom added by framework table
 * in email listing page.
 */
const MainSection = ({
  children
}) => /*#__PURE__*/_jsx("main", {
  children: children
});
function ManageFrameworkContainer() {
  const {
    history,
    location,
    params,
    query
  } = useRouter();
  const dispatch = useDispatch();
  const isUngatedForFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const {
    loading: isLoadingEmptyState,
    shouldRender: shouldRenderEmptyState
  } = useEmptyState();
  const isFree = useSelector(getIsFreeEmail);
  const isStarter = useSelector(getIsStarterEmail);
  const portalHasEmails = useSelector(getHasEmailsData);
  const showPortalSuspensionMessage = useSelector(showPortalSuspensionSelector);
  const showMc0653Variation = useSelector(getShowMc0653Variation);
  const portalCreditsUsed = useSelector(getEmailCreditUsed);
  const hasUsersAndTeamsAccess = useSelector(getHasUsersTeamsAccess);
  const feedbackClient = useSelector(feedbackClientSelector);
  const hasArchivedEmails = useSelector(getHasArchivedEmailsData);
  const shouldDisableCreateEmailAction = useSelector(getShouldDisableCreateEmailAction);
  const selectedCrmObject = useSelector(getSelectedEmailCrmObject);
  const hasAssignAssetAccess = useSelector(getHasAssignAssetAccess);
  const shouldUseBUPicker = useSelector(getShouldUseBUPicker);
  const hasAccessToEmailApprovalReadScope = useSelector(getHasAccessToEmailApprovalReadScope);
  const isMc0653Audience = useSelector(getIsMc0653Audience);
  const limitsOpen = useMemo(() => {
    return location.pathname.includes('/limits');
  }, [location]);
  const whitelistingOpen = useMemo(() => {
    return location.pathname.includes('/whitelisting');
  }, [location]);
  const autoStartOnboarding = useMemo(() => {
    return shouldRenderEmptyState || !portalHasEmails;
  }, [shouldRenderEmptyState, portalHasEmails]);
  const showAssignAssetAccessPanel = useMemo(() => {
    return Boolean(query.requestedAssetId) && Boolean(query.targetUserId) && hasAssignAssetAccess;
  }, [hasAssignAssetAccess, query.requestedAssetId, query.targetUserId]);
  const selectedViewPath = useMemo(() => {
    return params.state || query.state || 'all';
  }, [params, query.state]);
  const onClearEmailSearch = useCallback(() => {
    dispatch(clearEmailSearch());
  }, [dispatch]);
  const onSelectState = useCallback(state => {
    dispatch(selectState(state));
  }, [dispatch]);
  const trackScreenChange = useCallback(() => {
    trackDashboardScreenChange('dashboard', 'manage', params.state);
  }, [params.state]);
  const onSetComparisonToolReturnLocation = useCallback(value => {
    dispatch(setComparisonToolReturnLocation(value));
  }, [dispatch]);
  const onUpdateQueryAndPathParams = useCallback((queryParams, pathParams, fetchFunc, newPath, resetParams) => {
    dispatch(updateQueryAndPathParams(queryParams, pathParams, fetchFunc, newPath, resetParams));
  }, [dispatch]);
  const onUpdateQueryParams = useCallback(queryParams => {
    dispatch(updateQueryParams(queryParams));
  }, [dispatch]);
  useTrackerWithSR(shouldRenderEmptyState);
  const renderTable = useCallback(() => {
    if (isLoadingEmptyState) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      });
    }
    if (shouldRenderEmptyState) {
      return /*#__PURE__*/_jsx(EmptyStateWithTemplatesAsync, {}, "onboarding-empty-state-with-templates");
    }
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(FrameworkTable, {
        feedbackClient: feedbackClient,
        hasArchivedEmails: hasArchivedEmails,
        hasUsersAndTeamsAccess: hasUsersAndTeamsAccess,
        listMode: 'list',
        onClearEmailSearch: onClearEmailSearch,
        portalHasEmails: portalHasEmails,
        selectState: onSelectState,
        selectedViewPath: selectedViewPath,
        shouldDisableCreateEmailAction: shouldDisableCreateEmailAction
      }, "frameworkTable")
    }, "frameworkTableErrorBoundary");
  }, [isLoadingEmptyState, shouldRenderEmptyState, feedbackClient, hasArchivedEmails, hasUsersAndTeamsAccess, onClearEmailSearch, portalHasEmails, onSelectState, selectedViewPath, shouldDisableCreateEmailAction]);
  useEffect(() => {
    trackScreenChange();
    const buFromLocalStorage = getBUFromLocalStorage();
    if (shouldUseBUPicker && buFromLocalStorage !== ALL_BUSINESS_UNITS) {
      query.businessUnitId = buFromLocalStorage;
    }
    initParams(query, params, () => {});
    if (query && Object.keys(query).length > 0 && location.pathname) {
      history.push(`${history.location.pathname}${'?'.concat(stringify(query))}`);
    }
    void dispatch(maybeFetchHasArchivedEmailsByCrmSearch());
    void dispatch(maybeFetchHasEmailsByCrmSearch());
    if (query.enroll) {
      // Allow page to settle first; first load is very expensive
      setTimeout(() => {
        void dispatch(enrollPortalForGettingStarted());
      }, 500);
    }
    if (feedbackClient) {
      feedbackClient.reset();
    }
    void dispatch(fetchSentEmailsCount());
    if (hasAccessToEmailApprovalReadScope) {
      void dispatch(fetchApprovalsConfig());
    }
    if (isMc0653Audience) {
      logTreatmentExposure(MC0653_TREATMENT_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(EmailPageContainer, {
    children: [showPortalSuspensionMessage && /*#__PURE__*/_jsx(ErrorBoundary, {
      type: "info",
      children: /*#__PURE__*/_jsx(AsyncPortalSuspensionAlertContainer, {})
    }), showMc0653Variation && /*#__PURE__*/_jsx(MC0653UsageLimitBanner, {
      value: portalCreditsUsed,
      limit: 2000,
      displayThreshold: 1500
    }), /*#__PURE__*/_jsxs(FrameworkTableProvider, {
      onQueryChange: search => {
        if (search) {
          onUpdateQueryParams({
            search
          });
        } else {
          onUpdateQueryParams({
            search: null
          });
        }
      },
      children: [/*#__PURE__*/_jsx(ListingPage, {
        headerComponent: !shouldRenderEmptyState && /*#__PURE__*/_jsxs(ErrorBoundary, {
          children: [/*#__PURE__*/_jsx(Header, {
            autoStartOnboarding: autoStartOnboarding,
            EmailHeaderSubtitle: EmailHeaderSubtitle,
            fetchFunc: fetchEmails,
            isFree: isFree,
            isInNewUserState: shouldRenderEmptyState,
            isStarter: isStarter,
            limitsOpen: limitsOpen,
            location: history.location,
            shouldRenderMoreToolsButton: true,
            setComparisonToolReturnLocation: onSetComparisonToolReturnLocation // this is typed wrong
            ,
            source: "email-management",
            updateQueryAndPathParams: onUpdateQueryAndPathParams,
            whitelistingOpen: whitelistingOpen,
            AsyncMoreToolsModalContainer: AsyncMoreToolsModalContainer,
            router: router,
            portalCreditsUsed: portalCreditsUsed,
            showMc0653Variation: showMc0653Variation,
            emailCreationComponent: CreateEmailPanel
          }), /*#__PURE__*/_jsx(AsyncSuspensionBanner, {}), /*#__PURE__*/_jsx(AsyncListingAlert, {}), /*#__PURE__*/_jsx(AsyncProbationBannerContainer, {
            source: "MANAGE"
          })]
        }),
        MainSection: MainSection,
        pageLayout: "full-width",
        children: /*#__PURE__*/_jsxs(InsightContextProvider, {
          children: [/*#__PURE__*/_jsxs(ErrorBoundary, {
            type: "info",
            children: [/*#__PURE__*/_jsx(AsyncBannerTableContainer, {}, "bannerTable"), /*#__PURE__*/_jsx(AsyncYearInReviewBannerWrapper, {})]
          }, "bannerTableErrorBoundary"), renderTable(), selectedCrmObject && /*#__PURE__*/_jsx(ErrorBoundary, {
            type: "alert",
            children: /*#__PURE__*/_jsx(AsyncDetailsPanel, {
              crmObject: selectedCrmObject
            })
          }, "sidePanelErrorBoundary"), showAssignAssetAccessPanel && /*#__PURE__*/_jsx(ErrorBoundary, {
            type: "alert",
            children: /*#__PURE__*/_jsx(AsyncAssignAssetAccessPanelContainer, {
              queryParams: query
            }, "assignAssetAccessPanel")
          }, "teamPanelErrorBoundary")]
        })
      }), /*#__PURE__*/_jsx(AsyncMarketingHomePopup, {})]
    }), isUngatedForFrameworkFolders && /*#__PURE__*/_jsx(OnboardingTour, {
      tourId: EMAIL_FRAMEWORK_FOLDERS_TOUR_ID,
      tour: emailFrameworkFoldersTour
    })]
  });
}
export default manageEmailPrefetcher(ManageFrameworkContainer);